/**
 * components/hazard/SaveBarSection.js — Доорх товчны мөр.
 *
 * Props:
 *   onSave         : () => void
 *   onArchive      : Optional — () => void   (архивлах)
 *   onDraft        : Optional — () => void   (ноорог хадгалах)
 *   onCancel       : Optional — () => void
 *   saving         : boolean
 *   archiving      : boolean
 *   primaryLabel   : default "Илгээх"
 *   archiveLabel   : default "Архивлах"
 *   draftLabel     : default "Ноорог хадгалах"
 */
import React from "react";
import { RED } from "./common";

export default function SaveBarSection({
  onSave,
  onArchive,
  onDraft,
  onCancel,
  saving = false,
  archiving = false,
  primaryLabel = "Илгээх",
  archiveLabel = "Архивлах",
  draftLabel = "Ноорог хадгалах",
}) {
  return (
    <div
      className="hz-actions"
      style={{
        display: "flex",
        gap: 10,
        flexWrap: "wrap",
        marginTop: 4,
      }}
    >
      {onDraft && (
        <button
          type="button"
          onClick={onDraft}
          className="hz-draft-btn"
          style={{
            flex: 1,
            padding: "12px 0",
            borderRadius: 10,
            border: "1px solid #DDE1E8",
            background: "#fff",
            color: "#3A4153",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          <i className="fas fa-save" style={{ marginRight: 6 }} />
          {draftLabel}
        </button>
      )}

      {onArchive && (
        <button
          type="button"
          onClick={onArchive}
          disabled={archiving}
          style={{
            flex: 1,
            padding: "12px 0",
            borderRadius: 10,
            border: "1px solid #DDE1E8",
            background: "#F0F7FF",
            color: "#0050B3",
            fontSize: 14,
            fontWeight: 700,
            cursor: archiving ? "not-allowed" : "pointer",
            opacity: archiving ? 0.6 : 1,
          }}
        >
          <i className="fas fa-archive" style={{ marginRight: 6 }} />
          {archiving ? "Архивлаж байна..." : archiveLabel}
        </button>
      )}

      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          style={{
            flex: 1,
            padding: "12px 0",
            borderRadius: 10,
            border: "1px solid #DDE1E8",
            background: "#fff",
            color: "#7A8496",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Болих
        </button>
      )}

      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        style={{
          padding: "12px 0",
          borderRadius: 10,
          border: "none",
          background: RED,
          color: "#fff",
          fontSize: 14,
          fontWeight: 700,
          cursor: saving ? "not-allowed" : "pointer",
          opacity: saving ? 0.7 : 1,
          flex: 1,
        }}
      >
        <i className="fas fa-paper-plane" style={{ marginRight: 6 }} />
        {saving ? "Илгээгдэж байна..." : primaryLabel}
      </button>
    </div>
  );
}
